import React from 'react';
import { Helmet } from 'react-helmet-async';
import SupportQuestions from './SupportQuestions';
import useRouter from '../../hooks/useRouter';
import PageHeading from '../../@communityshare/ui/PageHeading';
import Results from '../_common_results/Results';
import SupportQuestion from './SupportQuestion';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import MobileNavigation from '../manage/MobileNavigation';
import useDialogLauncher from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '../../dialogs_new/DialogManager';
import SecondaryAction from '../_components/actions/SecondaryAction';
import useEducatorSupportQuestions from './useEducatorSupportQuestions';
import usePartnerSupportQuestions from './usePartnerSupportQuestions';
import Section from './Section';

export default function Layout(props) {
  const router = useRouter();
  const launch = useDialogLauncher();

  const educatorSupportQuestions = useEducatorSupportQuestions({});
  const partnerSupportQuestions = usePartnerSupportQuestions({});

  function onClick() {
    launch(DialogManager.SupportQuestionCreate.Config());
  }

  return (
    <div className="p-8 space-y-8">
      <Helmet>
        <title>Manage: Support Questions</title>
      </Helmet>
      <MobileNavigation />
      <PageHeading
        breadcrumbs={['Manage']}
        title="Support Questions"
        description={(
          <>
            This page shows all support questions.
          </>
        )}
      >
        <div>
          <SecondaryAction onClick={onClick} secret={true}>
            Create Support Question
          </SecondaryAction>
        </div>
      </PageHeading>
      {/*<SupportQuestions router={router}>*/}
      {/*  {function(result) {*/}
      {/*    return (*/}
      {/*      <Results result={result} columns={1} resource="support questions" emptyIcon={QuestionMarkCircleIcon}>*/}
      {/*        {function(supportQuestion, index) {*/}
      {/*          return (*/}
      {/*            <SupportQuestion*/}
      {/*              key={index}*/}
      {/*              supportQuestion={supportQuestion}*/}
      {/*            />*/}
      {/*          );*/}
      {/*        }}*/}
      {/*      </Results>*/}
      {/*    );*/}
      {/*  }}*/}
      {/*</SupportQuestions>*/}
      {educatorSupportQuestions.data.length > 0 && (
        <Section title="Educator Questions">
          <div className="space-y-8">
            {educatorSupportQuestions.data.map(function(supportQuestion) {
              return (
                <SupportQuestion
                  key={supportQuestion.id}
                  supportQuestion={supportQuestion}
                />
              );
            })}
          </div>
        </Section>
      )}
      {partnerSupportQuestions.data.length > 0 && (
        <Section title="Partner Questions">
          <div className="space-y-8">
            {partnerSupportQuestions.data.map(function(supportQuestion) {
              return (
                <SupportQuestion
                  key={supportQuestion.id}
                  supportQuestion={supportQuestion}
                />
              );
            })}
          </div>
        </Section>
      )}
    </div>
  );
}
